import { useEffect, useState } from 'react';

const ConsoleErrorDisplay = () => {
    const [consoleLogs, setConsoleLogs] = useState<string[]>([]);
    const originalConsoleError = console.error;

    console.error = (...args) => {
        setConsoleLogs((prevLogs) => [JSON.stringify(args), ...prevLogs]);
        originalConsoleError(...args);
    };

    const handleReplaceConsoleError = () => {
        window.onerror = (message, source, lineno, colno, error) => {
            setConsoleLogs((prevLogs) => [`Error: ${message} at ${source}:${lineno}:${colno} - ${error?.stack}`, ...prevLogs]);
            originalConsoleError(`Error: ${message} at ${source}:${lineno}:${colno}`, error);
        };
        window.onunhandledrejection = (event) => {
            setConsoleLogs((prevLogs) => [`Unhandled Rejection: ${event.reason}`, ...prevLogs]);
            originalConsoleError(`Unhandled Rejection: ${event.reason}`);
        };
    };

    useEffect(() => {
        handleReplaceConsoleError();
        return () => {
            console.error = originalConsoleError;
        };
    }, []);

    if (consoleLogs.length === 0) return null;
    return (
        <div className="block w-full box-border p-4 bg-red-100 border border-red-400 rounded text-sm text-black max-h-[200px] overflow-y-auto">
            <div className="grid grid-cols-1 break-all">
                {consoleLogs.map((err, index) => (
                    <div className="list-none" key={index}>
                        - {err}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConsoleErrorDisplay;
